import { WAVE_PROD, WAVE_TEST } from '@anm/constants/domains';
import { POPOVER_SCRIPT_NAME } from '@anm/constants/embed';

const isProd = process.env.TS_ENV === 'prod';

const getPopoverUrl = () => {
  const scriptLocation = `${isProd ? WAVE_PROD : WAVE_TEST}embed/`;

  return `${scriptLocation}${POPOVER_SCRIPT_NAME}.js`;
};

export default getPopoverUrl;
